import React from "react";
import Profile from "./Profile";
import Characteristics from "./Characteristics";

const PokemonProfileCard = ({}) => {

    return (
        <div className="pokemon-profile-card d-flex flex-column">

            <h2 className='text-center'>Profile</h2>
            <hr />

            <Profile />
            <Characteristics />
        </div>
    );
}

export default PokemonProfileCard;